export default "__VITE_ASSET__D$Eo_er4__"